<!--
 * @Description: 查看面板
 * @Autor: zczhang
 * @Date: 2021-03-11 09:55:23
 * @LastEditors: zczhang
 * @LastEditTime: 2021-03-16 16:24:34
-->
<template>
  <div class="personInfo">
    <div class="formBox">
      <el-form
        :model="formModel"
        label-width="80px"
        label-position="right"
      >
        <div class="item">
          <el-form-item
            label="姓名:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.name"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="身份证号:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.customerIdcard"
              disabled
            ></el-input>
          </el-form-item>
        </div>

        <div class="item">
          <el-form-item
            label="性别:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.customerSex"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="出生年月:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.customerBirthday"
              disabled
            ></el-input>
          </el-form-item>
        </div>

        <div class="item">
          <el-form-item
            label="民族:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.name"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="年龄:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.customerAge"
              disabled
            ></el-input>
          </el-form-item>
        </div>

        <div
          class="item"
          style="width:100%"
        >
          <el-form-item
            label="手机号码:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.customerPhone"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="政治面貌:"
            style="width:48%"
          >
            <el-select
              v-model="formModel.customerPolitical"
              disabled
            >
              <el-option
                label="中共党员"
                value="0"
              ></el-option>
              <el-option
                label="共青团员"
                value="1"
              ></el-option>
              <el-option
                label="群众"
                value="2"
              ></el-option>
              <el-option
                label="其他"
                value="3"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="item">
          <el-form-item
            label="人员编号:"
            style="width:48%"
          >
            <el-input
              v-model="formModel.faceIdcode"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="组织机构:"
            style="width:48%"
          >
            <el-select
              style="width: 100%"
              class="marginT34"
              v-model="formModel.orgName"
              placeholder="请选择组织机构"
              ref="selectBoxRef"
              disabled
            >
              <el-option
                :value="formModel.orgName"
                style="height: auto"
              >
                <el-tree
                  :data="orgList"
                  :props="defaultProps"
                  ref="tree"
                  @node-click="handleEditNodeClick"
                  class="tree_box"
                ></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <div class="item">
          <el-form-item
            label="居住情况:"
            style="width:100%"
          >
            <el-radio
              v-model="formModel.customerJzqk"
              label="1"
              disabled
            >独自居住</el-radio>
            <el-radio
              v-model="formModel.customerJzqk"
              label="2"
              disabled
            >与配偶居住</el-radio>
            <el-radio
              v-model="formModel.customerJzqk"
              label="3"
              disabled
            >与子女居住</el-radio>
            <el-radio
              v-model="formModel.customerJzqk"
              label="4"
              disabled
            >其他</el-radio>
          </el-form-item>
        </div>

        <div class="item">
          <el-form-item
            label="经济来源:"
            style="width:100%"
          >
            <el-checkbox-group
              v-model="formModel.economySource"
              disabled
            >
              <el-checkbox label="0">养老金</el-checkbox>
              <el-checkbox label="1">子女供养</el-checkbox>
              <el-checkbox label="2">救济优抚</el-checkbox>
              <el-checkbox label="3">兼职</el-checkbox>
              <el-checkbox label="4">其他</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="formImageBox">
      <el-upload
        class="avatar-uploader"
        :show-file-list="false"
        disabled
        :action="''"
      >
        <img
          v-if="formModel.imgUrl"
          :src="formModel.imgUrl"
          class="avatar"
        >
        <i
          v-else
          class="el-icon-plus avatar-uploader-icon"
        ></i>
      </el-upload>
    </div>
  </div>
</template>

<script>
import common from "@/utils/common.js"
import request from "@/utils/request.js"
import { getDataOfPersonInfo } from "../api/index.js"

export default {
  props: ["openData"],
  data() {
    return {
      arrOrgList: [],
      orgList: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      formModel: {
        customerName: "",
        customerIdcard: "",
        customerBirthday: "",
        customerAge: "",
        customerSex: "",
        customerPhone: "",
        customerPolitical: "",
        economySource: ["1"],
        orgName: "",
        orgId: "",
        faceIdcode: "",
        name: "张三",
        imgUrl:
          "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg",
        customerJzqk: "",
      },
    }
  },
  methods: {
    // async departmentlist() {
    //   let params = {
    //     pageNo: this.pageNo,
    //     pageSize: this.pageSize,
    //     webfrom: "1",
    //     qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
    //     shengjiId: JSON.parse(localStorage.getItem("czUserInfo")).shengjiId,
    //     shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
    //     stationId: JSON.parse(localStorage.getItem("czUserInfo")).stationId,
    //     shequjiId: JSON.parse(localStorage.getItem("czUserInfo")).shequjiId,
    //   }
    //   params = Object.assign({}, params)
    //   await request({
    //     url: "/sqyl/admin/department/info/findList",
    //     method: "POST",
    //     data: params,
    //   }).then((res) => {
    //     // console.log(res);
    //     this.subsidyLevelOptions = res.content.list
    //   })
    // },
    loopNode(node, arr) {
      if (node.parent == null) {
        return arr
      } else {
        arr.push(node.data.orgId)
        this.loopNode(node.parent, arr)
      }
    },
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/OrgTreelist",
          method: "POST",
          data: {},
        })
        .then((res) => {
          if (res.code == 200) {
            for (let i in res.content) {
              if (res.content[i].orgType == "1") {
                this.orgList.push(res.content[i])
              }
            }
            this.orgLevels = res.content[0].orgLevel
          }
        })
    },
    handleEditNodeClick(data, node) {
      const clickNode = this.$refs.tree.getNode(node)
      const arr = []
      this.loopNode(clickNode, arr)
      this.arrOrgList = arr
      let obj = common.organization(this.arrOrgList, this.orgLevels)
      this.$set(this.formModel, "orgId", data.orgId)
      this.$set(this.formModel, "parentId", data.parentId)
      this.$set(this.formModel, "orgType", data.orgType)
      this.$set(this.formModel, "orgName", data.label)

      this.$set(this.formModel, "qujiId", obj.qujiId)
      this.$set(this.formModel, "shengjiId", obj.shengjiId)
      this.$set(this.formModel, "shijiId", obj.shijiId)
      this.$set(this.formModel, "stationId", obj.stationId)
      this.$set(this.formModel, "shequjiId", obj.shequjiId)
    },
    getData() {
      let { id } = this.openData
      getDataOfPersonInfo({ id }).then(({ content }) => {
        this.formModel = {
          ...content,
          customerSex:
            content.customerSex == 0
              ? "男"
              : content.customerSex == 1
              ? "女"
              : "",
          economySource: content.economySource.split(","),
        }
        console.log(this.formModel);
        console.log("***********")
      })
    },
  },
  mounted() {
    this.getData()
    this.getOrg()
    //this.departmentlist()
  },
}
</script>

<style scoped>
.item {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.personInfo {
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
  display: flex;
}

.formBox {
  width: 75%;
  height: 100%;
  float: left;
}

.formImageBox {
  width: 25%;
  box-sizing: border-box;
  float: right;
  text-align: center;
}
</style>